import React from "react";
import "./AboutPage.css";

const AboutPage = () => {
  return (
    <div className="about-container">
      <div className="about-header">
        ab<span>out</span>
      </div>
      <div className="about-info">
        <div className="about-left">
        Passionate about building reliable, scalable backend systems —keeping things clean, simple, and efficient behind the scenes.
        </div>
        <div className="about-right">
          <p>
            I'm Akarsh Mishra, a passionate <span>Software Developer</span> currently pursuing my Master's in Computer Applications.
            I love working on real-world <span>web and system applications</span> that solve meaningful problems.
          </p>
          <p>
            I specialize in building clean and responsive <span>React</span> applications, and I’m also comfortable with
            <span> Node.js</span>, <span>Express</span>, <span>Java EE</span> and <span>Python</span>. I enjoy turning ideas into products
            that are <span>user-friendly</span> and <span>scalable</span>.
          </p>
          <p>
            Right now, I’m focused on sharpening my <span>backend development</span> skills,
            contributing to personal projects, and preparing for opportunities in <span>software engineering</span>.
          </p>

        </div>
      </div>
    </div>
  );
};

export default AboutPage;
